// extracted by mini-css-extract-plugin
module.exports = {"FilterWrapper":"styles_FilterWrapper__3Ij9e"};